import {
    Box,
    Button,
    HStack,
    Separator,
    Switch,
    Text,
    VStack,
    Dialog,
    Input,
    InputGroup,
} from "@chakra-ui/react";

import {
    useState,
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import {
    KeyRound,
    ShieldCheck,
    Laptop,
    ChevronRight,
    Eye,
    EyeOff,
} from "lucide-react";

import Card from "../../Dashboard/components/Card";

import {
    changePasswordAction,
} from "../../../state/actions/authActions";

import {
    toaster,
} from "../../../components/toaster";

import ActivityToast from "../../../components/ActivityToast";

const SettingRow = ({
    icon,
    title,
    description,
    action,
}) => (
    <>
        <HStack
            justify="space-between"
            align="center"
            py={2}
        >
            <HStack
                align="flex-start"
                gap={4}
            >
                <Box
                    bg="#EEF4FF"
                    color="#2453FF"
                    p={3}
                    borderRadius="12px"
                >
                    {icon}
                </Box>

                <Box>
                    <Text
                        fontWeight="600"
                        color="#071D54"
                    >
                        {title}
                    </Text>

                    <Text
                        fontSize="sm"
                        color="gray.500"
                        mt={1}
                    >
                        {description}
                    </Text>
                </Box>
            </HStack>

            {action}
        </HStack>

        <Separator />
    </>
);

const SecurityCard = () => {
    const dispatch =
        useDispatch();

    const {
        loading,
    } = useSelector(
        (state) =>
            state.auth
    );

    const [
        isPasswordOpen,
        setIsPasswordOpen,
    ] = useState(false);

    const [
        currentPassword,
        setCurrentPassword,
    ] = useState("");

    const [
        newPassword,
        setNewPassword,
    ] = useState("");

    const [
        confirmPassword,
        setConfirmPassword,
    ] = useState("");

    const [
        showCurrentPassword,
        setShowCurrentPassword,
    ] = useState(false);

    const [
        showNewPassword,
        setShowNewPassword,
    ] = useState(false);

    const [
        showConfirmPassword,
        setShowConfirmPassword,
    ] = useState(false);

    const handleChangePassword =
        async () => {
            if (
                newPassword !==
                confirmPassword
            ) {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="error"
                            title="Passwords Do Not Match"
                            description="Please ensure both passwords match."
                            timestamp="Just now"
                        />
                    ),
                });

                return;
            }

            const result =
                await dispatch(
                    changePasswordAction(
                        currentPassword,
                        newPassword
                    )
                );

            if (
                result?.success
            ) {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="success"
                            title="Password Changed"
                            description="Your password has been updated successfully."
                            timestamp="Just now"
                        />
                    ),
                });

                setCurrentPassword(
                    ""
                );

                setNewPassword(
                    ""
                );

                setConfirmPassword(
                    ""
                );

                setIsPasswordOpen(
                    false
                );
            } else {
                toaster.create({
                    render: () => (
                        <ActivityToast
                            type="error"
                            title="Password Change Failed"
                            description={
                                result?.error ||
                                "Unable to change password."
                            }
                            timestamp="Just now"
                        />
                    ),
                });
            }
        };

    return (
        <>
            <Card>
                <Text
                    fontSize="xl"
                    fontWeight="700"
                    color="#071D54"
                    mb={6}
                >
                    Security & Access
                </Text>

                <VStack
                    align="stretch"
                    gap={0}
                >
                    <SettingRow
                        icon={
                            <KeyRound
                                size={20}
                            />
                        }
                        title="Password"
                        description="Change your password every 3 months."
                        action={
                            <Button
                                size="sm"
                                variant="outline"
                                onClick={() =>
                                    setIsPasswordOpen(
                                        true
                                    )
                                }
                            >
                                Change
                            </Button>
                        }
                    />

                        {/* <SettingRow
                            icon={
                                <ShieldCheck
                                    size={20}
                                />
                            }
                            title="Two-Factor Authentication"
                            description="Protect your account with an additional verification step."
                            action={
                                <Switch.Root
                                    defaultChecked
                                    colorPalette="blue"
                                >
                                    <Switch.HiddenInput />
                                    <Switch.Control />
                                </Switch.Root>
                            }
                        />

                        <SettingRow
                            icon={
                                <Laptop
                                    size={20}
                                />
                            }
                            title="Active Sessions"
                            description="Manage devices currently signed in to your account."
                            action={
                                <Button
                                    size="sm"
                                    variant="ghost"
                                    color="#2453FF"
                                >
                                    View
                                    <ChevronRight
                                        size={16}
                                    />
                                </Button>
                            }
                        /> */}
                </VStack>
            </Card>

            <Dialog.Root
                open={
                    isPasswordOpen
                }
                onOpenChange={(
                    details
                ) =>
                    setIsPasswordOpen(
                        details.open
                    )
                }
            >
                <Dialog.Backdrop />

                <Dialog.Positioner>
                    <Dialog.Content
                        borderRadius="24px"
                    >
                        <Dialog.Header>
                            <Dialog.Title>
                                Change Password
                            </Dialog.Title>
                        </Dialog.Header>

                        <Dialog.Body>
                            <VStack gap={4}>
                                <InputGroup
                                    endElement={
                                        showCurrentPassword ? (
                                            <EyeOff
                                                size={
                                                    18
                                                }
                                                cursor="pointer"
                                                onClick={() =>
                                                    setShowCurrentPassword(
                                                        false
                                                    )
                                                }
                                            />
                                        ) : (
                                            <Eye
                                                size={
                                                    18
                                                }
                                                cursor="pointer"
                                                onClick={() =>
                                                    setShowCurrentPassword(
                                                        true
                                                    )
                                                }
                                            />
                                        )
                                    }
                                >
                                    <Input
                                        placeholder="Current Password"
                                        type={
                                            showCurrentPassword
                                                ? "text"
                                                : "password"
                                        }
                                        value={
                                            currentPassword
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setCurrentPassword(
                                                e
                                                    .target
                                                    .value
                                            )
                                        }
                                    />
                                </InputGroup>

                                <InputGroup
                                    endElement={
                                        showNewPassword ? (
                                            <EyeOff
                                                size={
                                                    18
                                                }
                                                cursor="pointer"
                                                onClick={() =>
                                                    setShowNewPassword(
                                                        false
                                                    )
                                                }
                                            />
                                        ) : (
                                            <Eye
                                                size={
                                                    18
                                                }
                                                cursor="pointer"
                                                onClick={() =>
                                                    setShowNewPassword(
                                                        true
                                                    )
                                                }
                                            />
                                        )
                                    }
                                >
                                    <Input
                                        placeholder="New Password"
                                        type={
                                            showNewPassword
                                                ? "text"
                                                : "password"
                                        }
                                        value={
                                            newPassword
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setNewPassword(
                                                e
                                                    .target
                                                    .value
                                            )
                                        }
                                    />
                                </InputGroup>

                                <InputGroup
                                    endElement={
                                        showConfirmPassword ? (
                                            <EyeOff
                                                size={
                                                    18
                                                }
                                                cursor="pointer"
                                                onClick={() =>
                                                    setShowConfirmPassword(
                                                        false
                                                    )
                                                }
                                            />
                                        ) : (
                                            <Eye
                                                size={
                                                    18
                                                }
                                                cursor="pointer"
                                                onClick={() =>
                                                    setShowConfirmPassword(
                                                        true
                                                    )
                                                }
                                            />
                                        )
                                    }
                                >
                                    <Input
                                        placeholder="Confirm New Password"
                                        type={
                                            showConfirmPassword
                                                ? "text"
                                                : "password"
                                        }
                                        value={
                                            confirmPassword
                                        }
                                        onChange={(
                                            e
                                        ) =>
                                            setConfirmPassword(
                                                e
                                                    .target
                                                    .value
                                            )
                                        }
                                    />
                                </InputGroup>
                            </VStack>
                        </Dialog.Body>

                        <Dialog.Footer>
                            <Button
                                variant="ghost"
                                onClick={() =>
                                    setIsPasswordOpen(
                                        false
                                    )
                                }
                            >
                                Cancel
                            </Button>

                            <Button
                                bg="#2453FF"
                                color="white"
                                loading={
                                    loading
                                }
                                loadingText="Updating..."
                                onClick={
                                    handleChangePassword
                                }
                                disabled={
                                    !currentPassword ||
                                    !newPassword ||
                                    !confirmPassword
                                }
                            >
                                Update Password
                            </Button>
                        </Dialog.Footer>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Dialog.Root>
        </>
    );
};

export default SecurityCard;